import { BRAND } from "../lib/constants";
import { BookNowButton, LabChip } from "./Shared";
import { Sparkles, ShieldCheck, Leaf } from "lucide-react";

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen pt-28 pb-20 sm:pt-32 overflow-hidden"
    >
      {/* Background layers */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(0,229,255,0.12),transparent_60%)]" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_left,rgba(0,229,255,0.08),transparent_55%)]" />
        <div
          className="absolute inset-0 opacity-[0.08]"
          style={{
            backgroundImage:
              "linear-gradient(to right, rgba(255,255,255,0.4) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,255,255,0.4) 1px, transparent 1px)",
            backgroundSize: "72px 72px",
            maskImage:
              "radial-gradient(ellipse at center, black 40%, transparent 75%)",
          }}
        />
      </div>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        {/* Left */}
        <div className="lg:col-span-7 fade-up">
          <LabChip testId="hero-chip">Precision Cleaning · Est. 2026</LabChip>
          <h1 className="mt-8 font-display text-5xl sm:text-6xl lg:text-7xl xl:text-[5.5rem] font-semibold leading-[0.95] tracking-tight">
            Clean,
            <br />
            <span className="italic font-light text-white/70">scientifically</span>{" "}
            <span className="text-[#00E5FF]">formulated.</span>
          </h1>
          <p className="mt-8 text-lg sm:text-xl text-white/60 font-body max-w-xl leading-relaxed">
            Homes, rentals, and exteriors treated like laboratory specimens —
            calibrated protocols, measured results, spotless outcomes.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <BookNowButton variant="primary" testId="hero-book-now" />
            <a
              href="#services"
              data-testid="hero-explore-btn"
              className="inline-flex items-center gap-2 rounded-full px-7 py-3 text-sm sm:text-base font-semibold border border-white/20 text-white hover:bg-white/10 transition-all font-body"
            >
              Explore Services
            </a>
          </div>

          <div className="mt-12 grid grid-cols-3 gap-4 sm:gap-8 max-w-lg">
            {[
              { icon: ShieldCheck, label: "Insured & bonded" },
              { icon: Leaf, label: "Eco-safe protocols" },
              { icon: Sparkles, label: "Satisfaction guaranteed" },
            ].map(({ icon: Icon, label }) => (
              <div key={label} className="flex flex-col gap-2">
                <Icon size={18} className="text-[#00E5FF]" />
                <span className="text-xs sm:text-sm text-white/60 font-body leading-snug">
                  {label}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Right - Logo showcase */}
        <div className="lg:col-span-5 relative fade-up" style={{ animationDelay: "0.2s" }}>
          <div className="relative aspect-square max-w-md mx-auto">
            <div className="absolute inset-0 rounded-full bg-[#00E5FF]/20 blur-[120px]" />
            <div className="relative h-full w-full rounded-[2rem] border border-white/10 bg-black/40 backdrop-blur-sm p-8 flex items-center justify-center overflow-hidden">
              {/* bubbles */}
              {[...Array(8)].map((_, i) => (
                <div
                  key={i}
                  className="absolute rounded-full bg-[#00E5FF]/40 bubble"
                  style={{
                    width: `${6 + (i % 3) * 4}px`,
                    height: `${6 + (i % 3) * 4}px`,
                    left: `${10 + i * 11}%`,
                    bottom: `${5 + (i % 4) * 8}%`,
                    animationDelay: `${i * 0.5}s`,
                  }}
                />
              ))}
              <img
                src={BRAND.logo}
                alt="The Neat Lab logo"
                data-testid="hero-logo-image"
                className="relative z-10 w-full h-full object-contain drop-shadow-[0_0_40px_rgba(0,229,255,0.35)]"
              />
            </div>
            {/* Corner tags */}
            <div className="absolute -top-3 -left-3 rounded-full border border-white/20 bg-black/80 px-3 py-1 text-[10px] font-mono uppercase tracking-[0.2em] text-white/70">
              Lab · 01
            </div>
            <div className="absolute -bottom-3 -right-3 rounded-full border border-[#00E5FF]/40 bg-black/80 px-3 py-1 text-[10px] font-mono uppercase tracking-[0.2em] text-[#00E5FF]">
              pH · balanced
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
